import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import VergelijkingskaartenDialog from './VergelijkingskaartenDialog';
const Footer = () => {
  const [kaartenOpen, setKaartenOpen] = useState(false);
  return <footer className="bg-secondary text-secondary-foreground" role="contentinfo">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <img src="/assets/a58bb8b6-4e5d-44da-944b-9eb16a731b59.png" alt="Compleet Verzekerd Logo" width="162" height="48" sizes="162px" loading="lazy" decoding="async" className="h-12 w-auto" />
            </div>
            
            <p className="text-secondary-foreground/80 mb-4">
              Persoonlijk, transparant en deskundig verzekeringsadvies voor particulieren en bedrijven.
            </p>
            
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-primary" />
                <a href="tel:0782200021" className="hover:text-primary transition-colors">078 - 220 00 21</a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-primary" />
                <span>info@compleetverzekerd.nl</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-primary" />
                <span>Van Eesterenplein 95, 3315 KT  Dordrecht</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <nav aria-labelledby="services-heading">
            <h3 id="services-heading" className="font-bold text-lg mb-4">Diensten</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/particulieren" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Particuliere verzekeringen
                </Link>
              </li>
              <li>
                <Link to="/studenten" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Studenten verzekeringen
                </Link>
              </li>
              <li>
                <Link to="/zakelijk" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Zakelijke verzekeringen
                </Link>
              </li>
              <li>
                <Link to="/hypotheken" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Hypotheken
                </Link>
              </li>
              <li>
                <Link to="/serviceabonnement" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Serviceabonnement
                </Link>
              </li>
              <li>
                <Link to="/schade" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Schademeldingen
                </Link>
              </li>
            </ul>
          </nav>

          {/* Quick Links */}
          <nav aria-labelledby="info-heading">
            <h3 id="info-heading" className="font-bold text-lg mb-4">Informatie</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/over-ons" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Over ons
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacybeleid" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Privacy beleid
                </Link>
              </li>
              <li>
                <Link to="/algemene-voorwaarden" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Algemene voorwaarden
                </Link>
              </li>
              <li>
                <Link to="/klachtenregeling" className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                  Klachtenregeling
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => setKaartenOpen(true)}
                  className="text-secondary-foreground/80 hover:text-primary transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1 text-left"
                >
                  Vergelijkingskaarten
                </button>
              </li>
            </ul>
          </nav>

          {/* Opening Hours */}
          <div>
            <h3 className="font-bold text-lg mb-4">Openingstijden</h3>
            <div className="space-y-2 text-secondary-foreground/80">
              <div className="flex justify-between">
                <span>Maandag - Vrijdag</span>
                <span>9:00 - 17:30</span>
              </div>
            </div>

            <div className="mt-6">
              <p className="text-sm text-secondary-foreground/80 mb-2">KVK-nummer:</p>
              <p className="text-sm font-semibold">83406662</p>
            </div>
            
            <div className="mt-6">
              <p className="text-sm text-secondary-foreground/80 mb-2">AFM-registratie:</p>
              <p className="text-sm font-semibold">12047090</p>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-foreground/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-secondary-foreground/80 text-sm">
              © {new Date().getFullYear()} Compleet Verzekerd. Alle rechten voorbehouden. 
              Website mede mogelijk gemaakt door <a href="https://www.cb-services.nl" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:no-underline focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded">CB Services</a>
            </p>
            <nav className="flex space-x-4 mt-4 md:mt-0" aria-label="Footer links">
              <Link to="/privacybeleid" className="text-secondary-foreground/80 hover:text-primary text-sm transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                Privacy
              </Link>
              <Link to="/cookies" className="text-secondary-foreground/80 hover:text-primary text-sm transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                Cookies
              </Link>
              <Link to="/disclaimer" className="text-secondary-foreground/80 hover:text-primary text-sm transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-1">
                Disclaimer
              </Link>
            </nav>
          </div>
        </div>
      </div>
      <VergelijkingskaartenDialog open={kaartenOpen} onOpenChange={setKaartenOpen} />
    </footer>;
};
export default Footer;